var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"size":_vm.size,"shape":_vm.shape,"type":_vm.type,"loading":_vm.loading,"disabled":_vm.disabled,"htmlType":_vm.htmlType,"icon":_vm.icon,"customIcon":_vm.customIcon,"ghost":_vm.ghost,"long":_vm.long},on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }